import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  token: string | null;
  user: any | null;
  userType: 'admin' | 'doctor' | null;
}

const initialState: AuthState = {
  token: localStorage.getItem('token') || null,
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  userType: localStorage.getItem('userType') as 'admin' | 'doctor' | null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<{ token: string; user: any; userType: 'admin' | 'doctor' }>) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.userType = action.payload.userType;
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('userType', action.payload.userType);
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.userType = null;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('userType');
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;

